import {
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from '@griply/types';

export const taskListGroupOptions = [
  GroupByMode.None,
  GroupByMode.Goal,
  GroupByMode.LifeArea,
  GroupByMode.Priority,
  GroupByMode.Type,
  GroupByMode.Deadline,
  GroupByMode.DeadlineDeadline,
  GroupByMode.Tag,
] as const satisfies TaskGroupBy[];

export const taskListSortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.DeadlineDeadline,
  SortingMode.CreatedAt,
  SortingMode.Name,
] as const satisfies SortingMode[];

export const taskListFilters = Object.values(FilterOptionKeys).filter(
  (filter) => filter !== FilterOptionKeys.CompletedAt,
) as FilterOptionKeys[];
